import {environment} from "environments";

class IdentificationPhotoController {
  constructor($rootScope, $scope, ngDialog, Logger, Media, Notifications, Orders, Constants, Polling, ADMIN_API_URL, Users) {
    'ngInject';

    Object.assign(this, {
      $rootScope,
      ngDialog,
      Logger,
      Media,
      Notifications,
      Orders,
      Constants,
      Polling,
      ADMIN_API_URL,
      Users,
      loading: false,
      error: null,
      errorMessage: '',
      photos: [],
      diagnosis: null,
      task: null,
      disableCTA: true,
      reviewer: null,
    });
  }

  $onInit() {
    this.init();
  }

  $doCheck() {
    this.disableCTA = !this.hasIdBeenCategorised();
  }
//DONE
  init() {
    this.task = this.visit.getTask(this.Orders.TASKS.ID_PHOTO);
    this.loading = true;
    this.Orders.getIdPhotos()
      .then(({ data }) => {
        let { diagnosis } = data;

        const photos = data.photos.map(photo => ({
          ...photo,
          rejected: photo.file && photo.file.status === this.Constants.PhotoStatuses.Rejected,
          deleted: photo.file && photo.file.deleted,
          approved: photo.file && photo.file.status === this.Constants.PhotoStatuses.Approved,
        }));

        Object.assign(this, {
          error: null,
          photos,
          diagnosis,
          types: data.id_types,
        });
        if (photos[0].approved) {
          this.Users.getOne(photos[0].file.reviewed_by)
            .then(({ data }) => {
              this.reviewer = data;
            })
        }

        this.disableCTA = !this.hasIdBeenCategorised();
        if (!this.photos.every(photo => photo.approved)) {
          this.startPoller();
        }
      })
      .catch(err => this.error = err.status === 404 ? 'No Photos Uploaded' : 'Error Downloading Photos')
      .finally(() => this.loading = false);
  }
  //DONE
  startPoller() {
    this.Polling.setupPoller(
      `${this.ADMIN_API_URL}/admin/orders/${this.visit.id}/idphotos?polling=true`,
      10000,
      (data) => {
        const hasSomePhotoChanged = data.photos.some((photo, index) => {
          return (photo.file && (photo.file.status !== this.photos[index].file.status))
            || (photo.file && (photo.file.filename !== this.photos[index].file.filename));
        });
        if (hasSomePhotoChanged) {
          this.photos = data.photos.map(photo => ({
            ...photo,
            rejected: photo.file && photo.file.status === this.Constants.PhotoStatuses.Rejected,
            deleted: photo.file && photo.file.deleted,
            approved: photo.file && photo.file.status === this.Constants.PhotoStatuses.Approved,
          }));
          const allApproved = this.photos.every(photo => photo.approved);
          if (allApproved) {
            this.$rootScope.$broadcast('photos:updated', true);
            this.$rootScope.$broadcast('visit:refresh');
            this.Polling.destroyPoller(`${this.API_URL}/admin/orders/${this.visit.id}/idphotos?polling=true`);
          }
        }
        this.disableCTA = !this.hasIdBeenCategorised();
      }
    );
  }
//DONE
  reload() {
    this.init();
  }
//DONE
  hasIdBeenCategorised() {
    if (this.types) {
      const idPhoto = this.photos.find(photo => photo.id === 13);
      if (idPhoto) {
        return !!idPhoto.file.id_type;
      }
      return true;
    }
    return true;
  }
//DONE
  approve(payload) {
    const reviews = payload.photos
      .map(photo => ({
        file_id: photo.file.id,
        approved: true,
        id_type: photo.file.id_type,
        notes: photo.notes,
      }));
    this.updatePhotoTask({ reviews }, true);
  }
//DONE
  reject(payload) {
    const reviews = payload.photos
      .filter(photo => photo.rejected)
      .map(photo => ({
        file_id: photo.file.id,
        approved: false,
        id_type: photo.file.id_type,
        notes: photo.notes,
        rejection_note: photo.file.rejection_note,
      }));
    this.updatePhotoTask({ reviews }, false);
  }
//DONE
  updatePhotoTask(payload, approved) {
    this.Orders.setIdPhotos(this.visit.id, payload).then(() => {
      // Set task status based on approval or rejection
      this.task.status = approved ? this.Orders.STATUS.APPROVED : this.Orders.STATUS.REJECTED;
      this.visit.admin_status = approved ? 5.6 : 5.7;

      this.photos = this.photos.map((photo) => {
        const isRejected = !approved && payload.reviews.find(({ file_id }) => file_id === photo.file.id);
        return {
          ...photo,
          file: {
            ...photo.file,
            status: approved
              ? this.Constants.PhotoStatuses.Approved
              : isRejected
                ? this.Constants.PhotoStatuses.Rejected
                : photo.file.status
          },
          rejected: isRejected,
          approved,
        };
      });

      this.diagnosis = payload.diagnosis;
      this.$rootScope.$broadcast('photos:updated', approved);
      this.$rootScope.$broadcast('visit:refresh');
    }).catch(err => {
      if (err.data.status == 403) {
        this.errorMessage = this.Notifications.orders.locked;
      } else if (err.data.status === 400) {
        this.errorMessage = this.Notifications.orders.photos.selfieUploadedSeparately;
      } else if (err.data.message && err.data.message.summary) {
        this.errorMessage = err.data.message.summary;
      } else {
        this.errorMessage = this.Notifications.orders.photos.failed;
      }
    });
  }
//DONE
  $onDestroy() {
    this.Polling.destroyPoller(`${this.API_URL}/admin/orders/${this.visit.id}/idphotos?polling=true`);
  }
}
IdentificationPhotoController.$inject = ["$rootScope", "$scope", "ngDialog", "Logger", "Media", "Notifications", "Orders", "Constants", "Polling", "ADMIN_API_URL", "Users"];
angular.module('pims').component('idPhotosOld', {
  templateUrl: 'app/views/visits/detail/sections/photos/identification/idPhotosOld.html',
  controller: IdentificationPhotoController,
  controllerAs: 'vm',
  bindings: {
    visit: '='
  }
});
